import { Route, Routes } from "react-router-dom";
import MarketingPage from "@/routes/MarketingPage";
import ConsolePage from "@/routes/ConsolePage";

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<MarketingPage />} />
      <Route path="/console" element={<ConsolePage />} />
      <Route path="*" element={<MarketingPage />} />
    </Routes>
  );
}
